import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const CustomerTransactionCard = ({ data }) => {
  const transactionData = data || {};

  const TRANSACTION_LABELS = {
    "Cash-In Frequency": {
      label: "Cash-In Frequency",
      tooltip: "The total number of times cash is deposited or credited into an account within a given month",
      unit: "Trx",
    },
    "Cash-Out Frequency": {
      label: "Cash-Out Frequency",
      tooltip: "The total number of times cash is withdrawn, transferred, or debited from an account within a given month",
      unit: "Trx",
    },
    "Cash In-Volume (Bn IDR)": {
      label: "Cash-In Volume",
      tooltip: "The total monetary value of all cash deposits or credits received in an account during a given month",
      unit: "Bn IDR",
    },

    "Cash-Out Volume (Bn IDR)": {
      label: "Cash-Out Volume",
      tooltip: "The total monetary value of all cash withdrawals, transfers, or debits from an account within a given month",
      unit: "Bn IDR",
    },
    "Posisi Saldo EOM (Bn IDR)": {
      label: "Posisi Saldo EOM",
      tooltip: "Total account balance recorded at the close of the last business day of the month",
      unit: "Bn IDR",
    },
    "Rerata Saldo YTD (Bn IDR)": {
      label: "Rerata Saldo YTD",
      tooltip: "The cumulative average of account balances from the beginning of the year up to the current date",
      unit: "Bn IDR",
    },
    "% Cash Out BNI vs Cash Out Total": {
      label: "%Cash out Own Bank vs Total",
      tooltip: "Proportion of total outgoing cash flows that remain within the bank (i.e., transfers to other accounts within Own Bank) versus the total cash outflows",
      unit: "%",
    },
    "%Closed Loop": {
      label: "% Closed - Loop",
      tooltip: "Total amount cash in for a year divided by total cash out to another Own Bank account (intrabank transfer)",
      unit: "%",
    },
  };

  return (
    <Box
      className="rounded-md py-2 px-4"
      style={{
        boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.1)",
        height: "60vh",
        overflowY: "auto",
      }}
    >
      <div className="grid grid-cols-2 gap-4">
        {Object.entries(TRANSACTION_LABELS).map(
          ([key, { label, tooltip, unit }]) => (
            <div
              key={key}
              className="rounded-md p-3"
              style={{
                border: "1px solid #E0E0E0",
              }}
            >
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs">{label}</span>
                <Tooltip title={tooltip}>
                  <InfoOutlinedIcon color="primary" fontSize="8px" />
                </Tooltip>
              </div>

              <div
                className="text-main font-bold p-1 rounded text-center text-xs"
                style={{
                  backgroundColor: "#F5F5F5",
                }}
              >
                {unit === "Bn IDR"
                  ? transactionData[key]?.toLocaleString().replace(/,/g, ".") +
                    " " +
                    unit
                  : transactionData[key] + " " + unit || "..."}
              </div>
            </div>
          )
        )}
      </div>
    </Box>
  );
};

export default CustomerTransactionCard;
